// #region Global Imports
import * as React from 'react';
// #endregion Global Imports
// #region Local Imports
import type { IProps } from '@components/Paragraphs/ParagraphMedia/Audio/Audio';
import { gql } from '@generated/gql';
import { getFragmentData } from '@generated/fragment-masking';
import styles from './Audio.module.sass';
// #endregion Local Imports
export const AudioFragment = gql(/* GraphQL */ `
  fragment AudioFragment on MediaAudio {
    audio: fieldMediaAudioFile {
      entity {
        url
        filemime
      }
    }
  }
`);
export const Audio: React.FunctionComponent<IProps.Audio> = ({
  audio: _audio,
}) => {
  const audio = getFragmentData(AudioFragment, _audio).audio;
  return (
    <div className={styles.Audio__root}>
      <div className={styles.Audio__wrapper}>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <audio className={styles.Audio__control} controls>
          <source
            src={String(audio?.entity?.url)}
            type={String(audio?.entity?.filemime)}
          />
        </audio>
      </div>
    </div>
  );
};
